export enum PendingTaskType {
ApproveLeave,
CheckLeaveData,
Information,
BackoffceSyncFailed,
ApproveResignation,
}
